import { useContext } from 'react';
import { CheckBox } from '../../../Common/ui-components';

const Simple = ({ globalContext, rsKeyFactors, setRsKeyFactorsFn }) => {
    return (
        <div className="adaptiveGrid-con adaptiveGrid Simple">
            {rsKeyFactors.map((item, i) => {
                const update = (e) => {
                    setRsKeyFactorsFn(e, item, i);
                };
                return (
                    <div
                        key={i}
                        className={`adaptiveGrid-item Simple ${item.checked ? 'adaptiveGrid-item-checked' : ''}`}
                        onClick={update}
                    >
                        <div className={`adaptiveGrid-item-left`}>
                            <CheckBox
                                size={16}
                                width={16}
                                shape="round"
                                checked={item.checked}
                                onChange={update}
                                background="#3FA33A"
                            />
                            <span>{item.title}</span>
                        </div>
                        <div
                            style={{ backgroundImage: `url(${process.env.PUBLIC_URL + '/img/' + item.className})` }}
                            className={`adaptiveGrid-item-right`}
                        ></div>
                    </div>
                );
            })}
        </div>
    );
};
export default Simple;
